import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { GoogleMapsStaticComponent } from "./google-maps-static.component";

@NgModule({
    declarations: [GoogleMapsStaticComponent],
    imports: [CommonModule],
    exports: [GoogleMapsStaticComponent],
})
export class GoogleMapsStaticModule {}
